import { Box, FormControl, InputLabel, MenuItem, Pagination, Select } from '@mui/material';
import { PAGE_SIZE_OPTIONS } from '../../hooks/usePagination';

type Props = {
  page: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
};

/** "Per page" select + page numbers, shown under a list. */
const PaginationBar = ({ page, totalPages, pageSize, onPageChange, onPageSizeChange }: Props) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mt: 3 }}>
    <FormControl size="small" sx={{ minWidth: 110 }}>
      <InputLabel>Per page</InputLabel>
      <Select label="Per page" value={pageSize} onChange={(e) => onPageSizeChange(Number(e.target.value))}>
        {PAGE_SIZE_OPTIONS.map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)}
      </Select>
    </FormControl>
    <Pagination count={totalPages} page={page} onChange={(_e, p) => onPageChange(p)} color="primary" shape="rounded" />
  </Box>
);

export default PaginationBar;
